module.exports = __webpack_public_path__ + "assets/img/xuzhou.8cd5e9b5.png";